import stylesheet_0 from '../stylesheets/0.js';

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.96554224.js","_app/immutable/chunks/scheduler.2887eafe.js","_app/immutable/chunks/index.387b3ba3.js","_app/immutable/chunks/four_planes.582a9558.js","_app/immutable/chunks/stores.c4b632c1.js","_app/immutable/chunks/singletons.7289561e.js","_app/immutable/chunks/index.544ab3ce.js"];
export const stylesheets = ["_app/immutable/assets/1.5707189e.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/1.5707189e.css": stylesheet_0
});
